import { gql } from "@medbillai/generated-graphql-types";

// Open active cases for the redesigned "Your cases" list. Deliberately NOT gated
// on hasActions (unlike getIssuesWithActionsQuery) — in-progress cases with no
// actions must still appear; actions are selected for the band.
export const getYourCasesQuery = gql(/* GraphQL */ `
  query GetYourCases {
    me {
      id
      issues(
        filter: { closedAt: { exists: false } }
        order: { openedAt: { dir: DESC } }
      ) {
        id
        title
        openedAt
        lastEvent {
          id
          sentAt
        }
        actions {
          id
          eventType
          actionRequired
          sentAt
        }
      }
    }
  }
`);

// Closed-case wins for the results lifecycle. Sourced from ClosedEvent because
// that's where the feedback link lives, so reviewed cases drop out here; the
// Resolved gate runs client-side (resolveClosedWin). Capped as a safety net —
// reviewing a win removes it, so any overflow surfaces on later fetches.
export const getClosedWinsQuery = gql(/* GraphQL */ `
  query GetClosedWins($userId: ID!) {
    issue__ClosedEvent(
      filter: {
        feedback: { exists: false }
        issue: { owner: { id: { eq: $userId } }, closedAt: { exists: true } }
      }
      order: { sentAt: { dir: DESC } }
      first: 15
    ) {
      id
      userClosureReason
      sentAt
      issue {
        id
        title
        caseType
        closedAt
        lastSeenAt
        caseManagementClosureReason
        dollarAmountSaved
        providerName
      }
    }
  }
`);
